import { getSubDomain } from "@/services/helper";

async function render(props = {}) {
  //empty
}

const loader = (loading: boolean) => render({ loading });

export const subApps = [
  {
    name: 'main-sydone_3126033173977255231',
    entry: 'http://localhost:29182',
    container: '#sub-main',
    loader,
    activeRule: ['/']
  },
  {
    name: 'iam-management_3126127733017412088',
    entry: 'http://localhost:3082',
    container: '#sub-iam',
    loader,
    activeRule: ['/iam']
  },
  {
    name: 'sydone_platform',
    entry: 'http://localhost:29173',
    container: '#sub-platform',
    loader,
    activeRule: ['/platform', '/contact', '/midone', '/enigma', '/management', '/knowledge']
  },
  /*
  {
    name: 'template',
    entry: 'http://localhost:29176',
    container: '#sub-iam',
    loader,
    activeRule: ['/management', '/top-menu/management', '/simple-menu/management']
  },*/

  {
    name: 'application-management_sub_3125615793803362420',
    entry: 'http://localhost:29171',
    container: '#sub_app_1',
    loader,
    activeRule: ['/management/application_sub', '/management/process']
  },
  // {
  //   name: 'contact-management',
  //   entry: 'http://localhost:29174',
  //   container: '#sub_app_1',
  //   loader,
  //   // @ts-ignore
  //   //activeRule: location => location.pathname.startsWith('/management/contact')
  //   activeRule: ['/management/contact', '/management/contact/:dynamicPath*', '/simple-menu/management/contact', '/simple-menu/management/contact/:dynamicPath*'
  // , '/top-menu/management/contact', '/top-menu/management/contact/:dynamicPath*']
  // },
  // {
  //   name: 'file-manager_3126199787871816961',
  //   entry: 'http://localhost:29190',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/file-manager']
  // },
  // {
  //   name: 'entity-settings_3126199787871817388',
  //   entry: 'http://localhost:29193',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/entity-settings']
  // },
  // {
  //   name: 'content-management_3126401318927729550',
  //   entry: 'http://localhost:29195',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/content-management-new']
  // },
  // {
  //   name: 'license-manager',
  //   entry: 'http://localhost:29190',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/license_manager', '/simple-menu/management/license_manager', '/top-menu/management/license_manager']
  // },
  {
    name: 'sort',
    entry: 'http://localhost:29189',
    container: '#sort-container',
    loader,
    activeRule: ['/management/application_sub', '/management/workflow-management']
  },
  {
    name: 'search',
    entry: 'http://localhost:29188',
    container: '#search-container',
    loader,
    activeRule: ['/management/application_sub', '/management/workflow-management']
  },
  {
    name: 'filter',
    entry: 'http://localhost:29186',
    container: '#filter-container',
    loader,
    activeRule: ['/management/application_sub', '/management/workflow-management']
  },
  {
    name: 'pagination',
    entry: 'http://localhost:29187',
    container: '#subapp-viewport-pagination',
    loader,
    activeRule: ['/management/application_sub', '/management/workflow-management']
  },
  {
    name: 'button',
    entry: 'http://localhost:29198',
    container: '#button-container',
    loader,
    activeRule: ['/management/application_sub', '/management/workflow-management',  '/management/process']
  },
  {
    name: 'columns',
    entry: 'http://localhost:29199',
    container: '#column-container',
    loader,
    activeRule: ['/management/application_sub', '/management/workflow-management']
  },
  {
    name: 'datalist',
    entry: 'http://localhost:29201',
    container: '#datalist-container',
    loader,
    activeRule: ['/management/application_sub', '/management/workflow-management', '/print']
  },
  {
    name: 'html-preview',
    entry: 'http://localhost:29211',
    container: '#sub_app_1',
    loader,
    activeRule: ['/management/html-preview']
  },
  {
    name: 'eagente',
    entry: 'http://localhost:3089',
    container: '#sub_app_1',
    loader,
    activeRule: ['/management/eagente']
  },
  // {
  //   name: 'multipart-form',
  //   entry: 'http://localhost:29202',
  //   container: '#multipart-form-container',
  //   loader,
  //   activeRule: ['/management/application_sub', '/management/workflow-management']
  // },
  // {
  //   name: 'uploader',
  //   entry: 'http://localhost:29191',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/uploader']
  // },
  // {
  //   name: 'communications',
  //   entry: 'http://localhost:29196',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/inbox', '/simple-menu/management/inbox', '/top-menu/management/inbox']
  // },
  //   {
  //   name: 'knowledge_management',
  //   entry: 'http://localhost:29172',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/knowledge', '/simple-menu/management/knowledge', '/top-menu/management/knowledge',
  // '/management/knowledge/:dynamicPath*', '/simple-menu/management/knowledge/:dynamicPath*', '/top-menu/management/knowledge/:dynamicPath*']
  // },
  // {
  //   name: 'workflow-management',
  //   entry: 'http://localhost:29204',
  //   container: '#sub_app_1',
  //   loader,
  //   activeRule: ['/management/workflow-management']
  // },
  // {
  //   name: 'process',
  //   entry: 'http://localhost:29205',
  //   container: '#process-container',
  //   loader,
  //   activeRule: ['/management/process']
  // },
  // {
  //   name: 'workflow',
  //   entry: 'http://localhost:29206',
  //   container: '#workflow-container',
  //   loader,
  //   activeRule: ['/management/process']
  // },
];